/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSelectionRelationType } from './PalReauthSelectionRelationType';
import {
    PalReauthSelectionRelationTypeFromJSON,
    PalReauthSelectionRelationTypeFromJSONTyped,
    PalReauthSelectionRelationTypeToJSON,
    PalReauthSelectionRelationTypeToJSONTyped,
} from './PalReauthSelectionRelationType';

/**
 * 
 * @export
 * @interface UpdatePalReauthDocumentSelection200ResponseData
 */
export interface UpdatePalReauthDocumentSelection200ResponseData {
    /**
     * 
     */
    relation_type: PalReauthSelectionRelationType;
    /**
     * 
     */
    relation_id: string;
    /**
     * 
     */
    is_selected: boolean;
}



/**
 * Check if a given object implements the UpdatePalReauthDocumentSelection200ResponseData interface.
 */
export function instanceOfUpdatePalReauthDocumentSelection200ResponseData(value: object): value is UpdatePalReauthDocumentSelection200ResponseData {
    if (!('relation_type' in value) || value['relation_type'] === undefined) return false;
    if (!('relation_id' in value) || value['relation_id'] === undefined) return false;
    if (!('is_selected' in value) || value['is_selected'] === undefined) return false;
    return true;
}

export function UpdatePalReauthDocumentSelection200ResponseDataFromJSON(json: any): UpdatePalReauthDocumentSelection200ResponseData {
    return UpdatePalReauthDocumentSelection200ResponseDataFromJSONTyped(json, false);
}

export function UpdatePalReauthDocumentSelection200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthDocumentSelection200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'relation_type': PalReauthSelectionRelationTypeFromJSON(json['relation_type']),
        'relation_id': json['relation_id'],
        'is_selected': json['is_selected'],
    };
}

export function UpdatePalReauthDocumentSelection200ResponseDataToJSON(json: any): UpdatePalReauthDocumentSelection200ResponseData {
    return UpdatePalReauthDocumentSelection200ResponseDataToJSONTyped(json, false);
}

export function UpdatePalReauthDocumentSelection200ResponseDataToJSONTyped(value?: UpdatePalReauthDocumentSelection200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relation_type': PalReauthSelectionRelationTypeToJSON(value['relation_type']),
        'relation_id': value['relation_id'],
        'is_selected': value['is_selected'],
    };
}

